import { clone } from 'lodash';

export const getTranslationData = (lang, val) => {

    const i18n = {
        "es_ES" : { // spanish lang
          "By": "Por",
          "MedicallyReviewedby": "Revisado Por",
          "Writtenby": "Escrito por",
          "WebMDEditorialContributors": "Colaboradores editoriales de WebMD",
          "January": "enero",
          "February": "febrero",
          "March": "marzo",
          "April": "abril",
          "May": "mayo",
          "June": "junio",
          "July": "julio",
          "August": "agosto",
          "September": "septiembre",
          "October": "octubre",
          "November": "noviembre",
          "December": "diciembre",
          "minread": "minutos de lectura",
          "Sources": "Fuentes",
          "UpdateHistory": "Actualizaciones",
          "ReviewerBio": "Bio del editor médico",
          "ViewFullBio": "Ver bio completa",
          "Print": "Imprimir",
          "Whatwouldyouliketoprint?": "Qué te gustaría imprimir?",
          "CompleteSlideshow": "Galería de fotos completa",
          "Slidetitlesandtext" : "Títulos y texto de las diapositivas",
          "butnoimages" : "sin imágenes",
          "Onlytitles": "Solo títulos",
          "PrintNow": "Imprimir",
          "historyHeader": "Cómo mantenemos actualizado nuestro contenido:",
          "historySubText": "Nuestro equipo médico y editorial sigue de cerca el ciclo de noticias de salud, nuevas investigaciones, aprobaciones de medicamentos, guías clínicas y otros avances médicos para asegurar que nuestro contenido reciba actualizaciones precisas y puntuales."          
        }
    };

    if (lang) {
      const copyLangStr = clone(val);
      if (lang && i18n[lang]) {
        // remove white spache from str value
        return i18n[lang][copyLangStr.replace(/\s/g, '')] || val;
      } else return val;
    }

    return val;
};
